import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tenko-associations-list" }
const _hoisted_2 = {
  key: 0,
  class: "list-loading"
}
const _hoisted_3 = {
  key: 1,
  class: "list-loading"
}
const _hoisted_4 = { class: "list list-scrollbar" }
const _hoisted_5 = { class: "table-header-row" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { colspan: "9" }

import AccountListRow from "@/components/TenkoAssociations/AccountListRow.vue";
import ResizableList from '@/components/ResizableList.vue';
import tenkoAssociationType from "@/types/responses/getIttenkoAssociation"
import { HEADERS } from "@/services/consts/tenko_associations";
import accountType from "@/types/account";
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountList',
  props: {
    tenkoAssociations: {},
    accounts: {},
    isSearched: { type: Boolean },
    isLoading: { type: Boolean },
    isUpdateAuthority: { type: Boolean },
    isDeleteAuthority: { type: Boolean }
  },
  emits: ['openUpdateModal', 'openDeleteModal'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;
const props = __props;

function openUpdateModal(account: accountType, employeeCd: string, isRegistered: boolean) {
  return emits('openUpdateModal', account, employeeCd, isRegistered)
}

function openDeleteModal(tenkoAssociation: tenkoAssociationType) {
  return emits('openDeleteModal', tenkoAssociation)
}

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!props.isSearched)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.runFilter')), 1)
        ]))
      : (props.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("label", null, _toDisplayString(_unref(i18n).global.t('pages.common.list.reading')), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(ResizableList, { scrollAreaSelector: ".list" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(HEADERS), (header) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: header,
                      class: "table-header column-space"
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("span", null, _toDisplayString(header), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (props.accounts.length)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(props.accounts, (account) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: account.id
                      }, [
                        _createVNode(AccountListRow, {
                          account: account,
                          tenkoAssociations: props.tenkoAssociations,
                          isUpdateAuthority: props.isUpdateAuthority,
                          isDeleteAuthority: props.isDeleteAuthority,
                          onOpenUpdateModal: openUpdateModal,
                          onOpenDeleteModal: openDeleteModal
                        }, null, 8, ["account", "tenkoAssociations", "isUpdateAuthority", "isDeleteAuthority"])
                      ]))
                    }), 128))
                  : (!props.accounts.length && props.isSearched && !props.isLoading)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                        _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(i18n).global.t('pages.common.list.noData')), 1)
                      ]))
                    : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})